import React from 'react';
import Page from '../UI/Page';
import LineChartTracker from './LineChartTracker';

  
const GrowthTracker = () => {

  return (
    <Page>
        <div className="hero" style={{minHeight: '100vh'}}>
            <LineChartTracker/>
        </div>
    </Page>
  )
}

export default GrowthTracker